import React, {useState, useEffect} from 'react';
import TransitionExpand from './TransitionExpand';
import classes from './index.css';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import WCRadarChart from './WCRadarChart';

export default function WorkroleCert(props){

    // console.log('workrole cert props');
    // console.log(props);

    useEffect(() => {
        if(props.parentSaved){
            Object.keys(props.parentSaved).forEach(key => {
                //this[key]=this.parentSaved[key]
            });
        }
    })

    const certHasRadar = (cert) =>{
        Object.keys(cert.reqinfo.reqs).forEach(reqid => {
            let req=cert.reqinfo.reqs[reqid]
            if (req.vals.radar){
                return true;
            }
        })
        return false;
    };

    const pwidth = () =>{
        //console.log(`At the time of render, pwidth was: ${window.innerWidth}`)
        return window.innerWidth * 0.8
    }

    const reqText = (orig) => {
        if (orig == "") {
            return `<div className={classes.noStatus}> Not Enough Data for Status </div>`;
        }
        return reactifyHtml(orig)
    }


    //i gave it a good effort to convert these classes into something that react will respect without any results
    //atm its not really worth my time to continue on this
    //definitely preferable to fix this on the backend instead ¯\_(ツ)_/¯
    const reactifyHtml = (string) =>{
        var captureClass= RegExp(/(class=")[a-z\d\-_\s]+(")/g);
        var modified = string.replace(captureClass, (match,token) => {
            var classNameCapturer = RegExp(/(")[a-z\d\-_\s]+(")/g);
            var replaced = match.match(classNameCapturer)[0];
            replaced = replaced.replaceAll('"', "");
            var doubleReplaced = "";
            var repArr = replaced.split(" " );
            for(var i = 0 ; i < repArr.length; i++){
                var rep = repArr[i]
                rep = "classes." + rep;
                if(i == repArr.length-1) doubleReplaced+= rep
                else doubleReplaced+= rep + "+ ' ' +";
            }
            replaced = doubleReplaced;
            replaced = "class={" + replaced + "}";
            return replaced;
        })
        return modified;
    }   
    var cert = props.cert


    const formatRadarChartData = () => {
        if(props.cert && props.cert.radar && props.cert.radar.data && 
            props.cert.radar.data.datasets && props.cert.radar.data.labels)
            {
                var rcdata = [
                    {
                        data:{

                        },
                        meta: {color:'#75A36A'}
                    },
                    {
                        data:{

                        },
                        meta:{color: '#1D1D1D'}
                    }

                ];
                var captions= {

                };
                var names = []; 
                
                var ds1 = props.cert.radar.data.datasets[0];
                var ds2 = props.cert.radar.data.datasets[1];
                var labels = props.cert.radar.data.labels;
                for(var i = 0; i < ds1.data.length; i++){
                    rcdata[0].data[labels[i].replace(' ', '')] = ds1.data[i] / 100;
                    rcdata[1].data[labels[i].replace(' ', '')] = ds2.data[i] / 100;
                    captions[labels[i].replace(' ', '')] = labels[i];
                }
                if(ds1.borderColor){
                    rcdata[0].meta.color = ds1.borderColor;
                }
                rcdata[0].meta.fill = ds1.backgroundColor;
                if(ds2.borderColor){
                    rcdata[1].meta.color = ds2.borderColor;
                }
                rcdata[1].meta.fill = ds2.backgroundColor;

                names.push(ds1.label);
                names.push(ds2.label);

                return({data: rcdata, captions: captions, names: names});
                
            }
    }

    var formatedradarChartData = formatRadarChartData();
    // console.log('formated radar chart data');
    // console.log(formatedradarChartData);
    var radarChartData = formatedradarChartData.data;
    var captions = formatedradarChartData.captions;
    var names = formatedradarChartData.names;
    // console.log(formatedradarChartData);

    return(
        <div className={classes.certBox + ' ' + classes.certExpanded}>
            <div>
                <h5>
                    {props.cert.name}
                </h5>
            </div>
            <TransitionExpand duration={500} height={true ? 'auto' : 0}>
                <div className={classes.radarBox}>
                    {(radarChartData && captions )&& <WCRadarChart data={radarChartData} captions={captions} names={names}/> }
                    <div className={classes.reqcontainer + ' ' + classes.fullFlex}>
                        {Object.keys(cert.reqinfo.reqs).map((reqid, kee) => {
                            var req = cert.reqinfo.reqs[reqid];
                            //works for now, change l8tr tho
                            var someHtml = reqText(cert.reqinfo.reqstatus[reqid][1]);
                            return(
                                <div className={classes.reqdetails} key={kee}>
                                    <h5>{req.req_record.shortname}</h5>
                                    <p>
                                        {ReactHtmlParser(req.req_record.description)}
                                    </p>
                                    <div>
                                        {ReactHtmlParser(someHtml)}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </TransitionExpand>
        </div>
    )
}